import * as moment from 'moment';
import * as React from 'react';
import { getLocale, localizedString } from '@locale/index';
import { AGENT_MODE, API, borderColor, defaultBorder } from '@config/index';
import { RightBar, NavBar, CopilotChat } from '@component/index';
import {
  AgentContextProps,
  AgentContext,
  AgentInfo,
  agentToLocal,
  OrgContext,
  OrgContextProps,
  OrgInfo,
  orgToLocal
} from '@interface/index';
import { Layout, ConfigProvider, message, Modal } from 'antd';
import { RouteComponentProps } from 'react-router-dom';
import { Sidebar as LocalSidebar } from './sidebar';
import { NavTab } from './nav-tab';
import { Topbar } from './topbar';
import '@style/layout/index.less';
import 'moment/locale/zh-cn';
import { IntlProvider } from 'react-intl';
import {
  getOrgNameFromUrl,
  getAgentNameFromUrl,
  getAgentLangFromUrl,
  getMasterAgentInfo,
  setMasterAgentInfo,
  getAgentId,
  PathKeys,
  PathKeyRegxMap,
  getUserId,
  getCtxFromLocation,
  isOrgOwner,
  isOrgMember
} from '@lib/index';
import { SubNav } from '@component/nav-bar/sub-nav';

import { getCopilotInstance } from '../../copilot';

const instance = getCopilotInstance();

const { Sider, Content, Header } = Layout;

moment.locale(getLocale().localeStr);

export type IPropsInfo = RouteComponentProps<{
}> & {
  content: React.ReactElement<any>;
  org: OrgInfo;
  handleOrg: (org?: OrgInfo) => void;
  agent: AgentInfo;
  handleAgent: (agent?: AgentInfo, org?: OrgInfo) => void;
};
export interface IStateInfo {
  collapsed: boolean;
  showCopliot: boolean;
}
export class DhlLayout extends React.Component<IPropsInfo, IStateInfo> {
  state: IStateInfo = { collapsed: false, showCopliot: window.localStorage.getItem(`show-copilot-${getUserId()}`) === 'true' };

  listener: (() => void) | undefined;

  mounted = false;
  async componentDidMount() {
    this.mounted = true;
    this.listener = this.props.history.listen(async (location: any, action: any) => {

      // this.updateCopilotCtx(location.location);
      if (this.mounted) {
        await this.refreshCache();
      }
    });
    // this.updateCopilotCtx(window.location);
    await this.refreshCache();
  }

  updateCopilotCtx(location: any) {
    instance.setDefaultParam('location', location);
  }

  componentWillUnmount() {
    this.mounted = false;
    if (this.listener) {
      this.listener();
    }
  }

  componentDidCatch() {
    const hostName = location.hostname;
    const version = '1.3.1';

    if (hostName === 'console.dev.naturali.io' || hostName === 'localhost') {
      document.title = `DEV-${version}-对话流`;
    } else if (hostName === 'console.pre-release.naturali.io') {
      document.title = `PRE-RELEASE-${version}-对话流`;
    } else if (hostName === 'console.naturali.io') {
      document.title = `对话流`;
    }
  }

  getPath = () => {
    return window.location.pathname;
  }

  getPopupContainer = () => {
    return document.getElementById('dashboard-layout-with-copilot') as HTMLElement;
  }

  render() {
    const state = this.state;
    const props = this.props;

    let structId = props.agent && props.agent.id;
    if (props.agent && props.agent.structKey) {
      structId = props.agent.structKey.agentId;
    }

    return (
      <IntlProvider locale={getLocale().localeStr} messages={getLocale().messages}>
        <ConfigProvider locale={getLocale().antdLocale}
          getPopupContainer={this.state.showCopliot ? this.getPopupContainer : undefined}
        >
          <Layout
            style={{ height: '100%', backgroundColor: 'white' }}
          >
            <Layout id={`dashboard-layout${state.showCopliot ? '-with-copilot' : ''}`}>
              <Header className="dhl-header" style={{ marginBottom: props.org && props.org.id && props.org.id.length ? 0 : 8 }}>
                <Topbar history={props.history}
                  org={props.org}
                  onCopilotClick={() => {
                    this.setState({ showCopliot: !state.showCopliot });
                    window.localStorage.setItem(`show-copilot-${getUserId()}`, !state.showCopliot ? 'true' : 'false');
                  }}
                  showCopilot={state.showCopliot}
                />
              </Header>
              {
                props.org && props.org.id && props.org.id.length &&
                <Header className="dhl-nav-header" style={{ height: 48, lineHeight: '48px', marginBottom: 1 }}>
                  <NavBar
                    key={`${props.org && props.org.id}${props.agent && props.agent.id}`}
                    history={props.history}
                    tabComp={
                      !this.isExplorePage() &&
                      // this.isBuildPage() &&
                      <NavTab
                        key={`${props.org && props.org.id}${props.agent && props.agent.id}`}
                        collapsed={state.collapsed}
                        history={props.history}
                      />}
                  />
                </Header>
              }
              {
                props.org && props.org.id && props.org.id.length &&
                props.agent && props.agent.id && props.agent.id.length &&
                props.agent.mode !== AGENT_MODE.KNOWLEDGE &&
                this.showSubnav() &&
                <Header className="dhl-nav-header" style={{ width: '100%', maxWidth: 1216, height: 48, margin: 'auto', borderTop: 'none', borderBottom: 'none', lineHeight: '48px' }}>
                  <SubNav key={props.agent && props.agent.id} history={props.history} />
                </Header>
              }
              <Layout className="admin-layout"
                style={{ margin: 'auto', background: 'white' }}
              // hasSider={true}
              >
                {
                  this.showSidebar() &&
                  <Sider
                    breakpoint="lg"
                    className="admin-sider"
                    collapsed={state.collapsed}
                    collapsible
                    width={236}
                    // tslint:disable-next-line
                    trigger={null}
                  >
                    {
                      <LocalSidebar
                        collapsed={state.collapsed}
                        history={props.history}
                      />
                    }
                  </Sider>
                }
                <Content>
                  <Layout style={{ height: '100%' }}>
                    <Content>{props.content}</Content>
                  </Layout>
                </Content>
              </Layout>
            </Layout>
            {
              isOrgMember() &&
              props.org.copilotEnabled &&
              state.showCopliot &&
              <Sider
                style={{ borderLeft: defaultBorder }}
                breakpoint="lg"
                className="admin-sider"
                collapsed={state.collapsed}
                collapsible
                width={536}
                // tslint:disable-next-line
                trigger={null}
              >
                <CopilotChat onClose={() => {
                  this.setState({ showCopliot: false });
                  window.localStorage.setItem(`show-copilot-${getUserId()}`, 'false');
                  instance.clearHistory();
                }} />
              </Sider>
            }

          </Layout>
        </ConfigProvider>
      </IntlProvider>
    );
  }

  showSidebar = () => {
    const path = window.location.pathname;

    for (const key of [
      // PathKeys.OrgList,
      // PathKeys.Account,
      PathKeys.AgentSetting,
      // PathKeys.OperateSetting,
      PathKeys.ProviderConnection,
      // PathKeys.OrgSetting,
      // PathKeys.OrgSettingCopilot,
      // PathKeys.OrgSettingBilling
    ]) {
      const v = PathKeyRegxMap[key];

      if (Array.isArray(v)) {
        for (const regex of v) {
          const ret = path.match(regex);
          if (ret && ret.length && ret[0] === path) {
            return true;
          }
        }
      } else {
        const ret = path.match(v);
        if (ret && ret.length && ret[0] === path) {
          return true;
        }
      }
    }
    return false;
  }

  showSubnav = () => {
    const path = window.location.pathname;
    // return !(path.endsWith('library') || path.endsWith('version'));
    return !path.endsWith('version') &&
      !path.endsWith('setting') &&
      !path.endsWith('deploy') &&
      !path.endsWith('debug') &&
      // !path.endsWith('library') &&
      !path.endsWith('readme') &&
      !path.endsWith('provider_connection') &&
      !path.endsWith('outbound');
  }

  isExplorePage = () => {
    const path = window.location.pathname;
    // return !(path.endsWith('library') || path.endsWith('version'));
    return path.endsWith('third_party');
  }

  refreshCache = async () => {
    const { handleAgent, handleOrg, history } = this.props;
    let { agent, org } = this.props;

    // const agentId = getAgentId();
    // const orgId = getOrgId();

    const orgName = getOrgNameFromUrl();

    if (orgName === 'new') {
      return;
    }

    const agentName = getAgentNameFromUrl();
    const agentLang = getAgentLangFromUrl();

    let masterAgent = getMasterAgentInfo();
    let orgChanged = false;
    let agentChanged = false;
    if (!orgName || !orgName.length) {
      handleOrg();
      handleAgent();
    } else if (!org || org.name !== orgName) {
      handleAgent();
      org = await API.org.get(undefined, orgName)
        .then(orgToLocal)
        .catch((err: Error) => {
          message.error(err.message);
          // handleOrg();
          history.push('/org');
          throw err;
        });
      handleOrg(org);
      orgChanged = true;
      if (agentName && agentName.length) {
        agentChanged = true;
      }
    } else if (!agentName || !agentName.length) {
      handleAgent();
    } else if (!masterAgent || masterAgent.name !== agentName || masterAgent.language !== agentLang) {
      handleAgent();
      agentChanged = true;
    }

    if (agentChanged) {
      masterAgent = (await API.agent.getMasterAgent(orgName || '', agentName || '', agentLang || '')
        .then(agentToLocal)
        .catch((err: Error) => {
          message.error(err.message);
          // handleAgent();
          history.push(`/org/${orgName}/`);
          throw err;
        }) as AgentInfo);

      setMasterAgentInfo(masterAgent);
      agent = (await API.agent.getAgentById(masterAgent.id || '').then(agentToLocal)
        .catch((err: Error) => {
          message.error(err.message);
        }) as AgentInfo);
      handleAgent(agent, org);
    }
  }

  fetchOrgInfo = async (orgId: string) => {
    return API.org.get(orgId)
      .then(orgToLocal)
      .catch((err: any) => {
        message.error(err.message);
        throw new Error(err.message);
      });
  }

  // fetchOrgInfoWithName = (orgName: string) => {
  //   return API.org.get(undefined, orgName)
  //     // .then(orgToLocal)
  //     .catch((err: any) => {
  //       message.error(err.message);
  //       throw new Error(err.message);
  //     });
  // }
}

export const DhlLayoutComp = (props: any) => (
  <OrgContext.Consumer>
    {($org: OrgContextProps) =>
      <AgentContext.Consumer>
        {($agent: AgentContextProps) => (
          <DhlLayout {...props} {...$agent} {...$org} />
        )}
      </AgentContext.Consumer>}
  </OrgContext.Consumer>
);
